<template>
    <div v-if="destinations.length" v-resize="onResize" dir="ltr">
        <main-header :title="$t('popular_destinations')" :subtitle="subtitle" />
        <swiper
            v-if="showSwiper"
            :modules="modules"
            :slides-per-view="slidesPerView"
            :space-between="20"
            navigation
            class="pa-4"
            @slide-change="updateLoop"
        >
            <swiper-slide
                v-for="(destination, index) in destinations"
                :key="index"
                :class="{'swiper-slide-ssr': swiperSlideSsr}"
            >
                <popular-destination
                    :destination="destination"
                    :dir="isRtl ? 'rtl' : 'ltr'"
                    @selected="search($event)"
                />
            </swiper-slide>
        </swiper>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import PopularDestination from '~src/components/parts/popularDestination.src'
    import {searchRequest} from '@/utils/hotels/hotels-blank-states'
    import MainHeader from '~src/components/snippets/mainHeader.src'
    import {SwiperMixin} from '@/components/mixins/SwiperMixin.vue'
    import {useRtl} from 'vuetify'
    import {Navigation, Pagination} from 'swiper/modules'
    import {Swiper, SwiperSlide} from 'swiper/vue'
    import 'swiper/css'
    import 'swiper/css/navigation'

    @Component({
        components: {
            PopularDestination,
            MainHeader,
            Swiper,
            SwiperSlide,
        },
    })
    export class PopularDestinations extends SwiperMixin {
        @Prop({required: true}) destinations

        modules = [Pagination, Navigation]
        swiperSlideSsr = false

        created() {
            this.swiperSlideSsr = !this.$breakpoint.smAndDown
        }

        async search({id: cityId}) {
            await this.$router.push(
                hotelsRuntimeStore.hotelsPageLink({
                    ...searchRequest(),
                    cityId,
                    citizenshipId: authStore.defaultCitizenshipId,
                })
            )
        }

        updateLoop(e) {
            e.loopDestroy()
            e.loopCreate()
        }

        get slidesPerView() {
            return this.$breakpoint.smAndDown ? 1 : this.$breakpoint.mdAndDown ? 4 : 5
        }

        get person() {
            return authStore.person
        }

        get items() {
            return this.destinations
        }

        get isRtl() {
            return useRtl().isRtl
        }

        get subtitle() {
            return null
        }
    }

    export default PopularDestinations
</script>

<style lang="scss" scoped>
    :deep(div.swiper-button-prev),
    :deep(div.swiper-button-next) {
        color: white;
        top: 142px;
    }
    :deep(div.swiper-button-prev) {
        left: 20px;
    }
    :deep(div.swiper-button-next) {
        right: 20px;
    }
    :deep(.swiper-slide-ssr) {
        width: 25%;
        margin-right: 20px;
        float: left;
    }
</style>
